/** Shared mini-board sizes for course previews, opening variations, and similar list tiles. */

/** Preview boards on phone-sized viewports. */
export const PREVIEW_BOARD_WIDTH_MOBILE = 112;

/** Default preview board width on desktop list rows. */
export const PREVIEW_BOARD_WIDTH = 176;

/** Preview boards on wide desktop (1920px+). */
export const PREVIEW_BOARD_WIDTH_WIDE = 260;

/** Preview boards on ultra-wide / 4K (2560px+). */
export const PREVIEW_BOARD_WIDTH_ULTRA = 320;

/** Typical number of preview boards shown side by side (e.g. course cards). */
export const DEFAULT_PREVIEW_BOARD_COUNT = 3;

export type PreviewBoardViewport = {
  isMobile: boolean;
  isWideDesktop: boolean;
  isUltraWide: boolean;
};

export const resolvePreviewBoardWidth = ({
  isMobile,
  isWideDesktop,
  isUltraWide,
}: PreviewBoardViewport): number => {
  if (isMobile) {
    return PREVIEW_BOARD_WIDTH_MOBILE;
  }
  if (isUltraWide) {
    return PREVIEW_BOARD_WIDTH_ULTRA;
  }
  if (isWideDesktop) {
    return PREVIEW_BOARD_WIDTH_WIDE;
  }
  return PREVIEW_BOARD_WIDTH;
};
